import ListIcon from '@assets/icons/faq-list.svg'
import BookIcon from '@assets/icons/faq-book.svg'
import CartIcon from '@assets/icons/faq-shopping-cart.svg'
import CancelIcon from '@assets/icons/faq-cancel.svg'
import IdeaIcon from '@assets/icons/faq-idea.svg'
import TransportIcon from '@assets/icons/faq-transport.svg'
import MuseumIcon from '@assets/icons/faq-attraction.svg'
import SmartphoneIcon from '@assets/icons/faq-smartphone.svg'

import httpClient from '@src/services/http.service'

const icons = [
  ListIcon,
  BookIcon,
  SmartphoneIcon,
  MuseumIcon,
  TransportIcon,
  CartIcon,
  CancelIcon,
  IdeaIcon
]

export const state = {
  faqs: [],
  pageData: [],
}

export const actions = {
  fetchFaqs: ({ commit }) => {
    Promise.all([httpClient.get('pages/5fe3148dc1478823bac06382'), httpClient.get('/faqCat'), httpClient.get('/faq')])
      .then(([pageResponse, categoriesResponse, faqsResponse]) => {
        commit('SET_PAGE_DATA', pageResponse.data)
        const categories = categoriesResponse.data
        const faqs = faqsResponse.data
        const result = categories.map((category, index) => ({
          id: category._id,
          title: category,
          data: faqs.filter(faq => category._id === faq.category),
          icon: icons[index]
        }))
        commit('SET_FAQS', result)
      })
  },
}

export const mutations = {
  SET_FAQS: (state, faqs) => {
    state.faqs = faqs
  },
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },
}

export const getters = {
  pageData: state => state.pageData,
  dataFAQ: state => state.faqs,
}
